import dayjs from 'dayjs';
import { AssignmentType } from '@application/common/enums/assignment-type';
import { ClientContractStatus } from '@application/common/enums/client-contract-status';
const dateLabel = (value) => {
    if (!value || (typeof value === 'string' && /^0\d{3}-/.test(value)))
        return '';
    return dayjs(value).isValid() && dayjs(value).year() > 1900 ? dayjs(value).format('DD MMM YYYY') : '';
};
export function assignmentLabel(assignment) {
    const start = dateLabel(assignment.contactStartDate);
    const end = dateLabel(assignment.contactEndDate);
    const dates = start && end ? `${start} – ${end}` : start ? `From ${start}` : end ? `Until ${end}` : '';
    const lifecycle = assignment.isArchived ? 'Archived' : assignment.status === ClientContractStatus.Expired ? 'Expired' :
        assignment.status === ClientContractStatus.Approved ? 'Approved' : '';
    return [assignment.clientName || 'Assignment', assignment.type === AssignmentType.Reason ? 'Internal' : '', dates,
        assignment.projectTaskNumber?.trim(), lifecycle].filter(Boolean).join(' · ');
}
export function assignmentOptions(assignments) {
    const labels = assignments.map(assignmentLabel);
    return assignments.map((assignment, index) => {
        const peers = assignments.filter((_, i) => labels[i] === labels[index]);
        let length = 8;
        while (length < assignment.id.length && peers.some(peer => peer.id !== assignment.id && peer.id.slice(0, length) === assignment.id.slice(0, length)))
            length += 4;
        return { value: assignment.id, label: labels[index] + (peers.length > 1 ? ` · Ref ${assignment.id.slice(0, length)}` : '') };
    });
}
